import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation  } from 'react-router-dom';
import '../scss/SingleProduct.scss';
import CallController from '../API/CallController'; 
import '../scss/responsive.scss';
import LinkifiedText from './LinkifiedText';

interface Product {
  id: number;
  name: string;
  description: string;
  price: number;
  discountedPrice?: number;
  imageUrl: string;
  priceUnit: string;
}

const SingleProduct: React.FC = () => {
  const { productId } = useParams<{ productId: string }>();
  const [product, setProduct] = useState<Product | null>(null);

  const location = useLocation();
  const state = location.state as { categoryId?: string } | undefined;
  const categoryId = state?.categoryId;

  useEffect(() => {
    if (!productId) return;

  fetch(CallController.GetProductWithActiveCampaignById(Number(productId)))
      .then(async (res) => {
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`Fel vid hämtning: ${res.status} - ${errorText}`);
        }
        return res.json();
      })
      .then((data) => setProduct(data))
      .catch((error) => console.error(error));
  }, [productId]);

  if (!product) {
    return <p>Laddar produkt...</p>;
  }

  return (
    <div className="single-product-container">
      <Link to={categoryId ? `/products/${categoryId}` : '/'} className="back-link">
        ← Tillbaka till produkter
      </Link>
      <div className="single-product">
        <img src={`https://accordi-web-eqb2byhxd0feffhu.norwayeast-01.azurewebsites.net${product.imageUrl}`} alt={product.name} className="product-image" />
        <div className="product-details">
          <h2>{product.name}</h2>
          <p className="product-description"><LinkifiedText text={product.description} /></p>
          <p className="product-price">
            {product.discountedPrice && product.discountedPrice < product.price ? (
              <>
                <span className="original-price">
                  {product.price} {product.priceUnit}
                </span>
                <span className="discounted-price">
                  {product.discountedPrice} {product.priceUnit}
                </span>
              </>
            ) : (
              <span className="normal-price">
                {product.price} {product.priceUnit}
              </span>
            )}
          </p>

        </div>
      </div>
    </div>
  );
};
export default SingleProduct;
